import BusinessIcon from '@mui/icons-material/Business';
// import CodeIcon from '@mui/icons-material/Code';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import InfoIcon from '@mui/icons-material/Info';
import ArticleIcon from '@mui/icons-material/Article';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import BusinessCenterSharpIcon from '@mui/icons-material/BusinessCenterSharp';
import MapIcon from '@mui/icons-material/Map';
import { StepConfig } from "../Components/shared";
import { ElementInterface } from '../Objects/interfaces/AppInterface';
import { ENV_VERIFIED_TRAINER, isBrandActive } from './environment.config';


export const stepsComplete: StepConfig[] = [
    {
        label: 'Statut juridique',
        subtitle: 'Statut',
        icon: <BusinessIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'Procuration SAP',
        subtitle: 'SAP',
        icon: <AssignmentIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'SIRET & Adresse',
        subtitle: 'SIRET',
        icon: <LocationOnIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'Arrêté préfectoral',
        subtitle: 'Arrêté',
        icon: <DescriptionIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'Signature',
        subtitle: 'Signature',
        icon: <EditIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'Terminé',
        subtitle: 'Terminé',
        icon: <CheckCircleIcon style={{ fontSize: '24px' }} />
    }
];
export const stepsProcurationAe: StepConfig[] = [
    {
        label: 'Procuration auto-entrepreneur et SAP',
        subtitle: 'Informations générales',
        icon: <AssignmentIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'Annexe 1',
        subtitle: 'Documents à joindre',
        icon: <AttachFileIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'Annexe 2',
        subtitle: 'Fiche de renseignement',
        icon: <ArticleIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'Annexe 3',
        subtitle: 'Fiche d’information NOVA',
        icon: <InfoIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'Signature',
        subtitle: 'Signer la procuration',
        icon: <EditIcon style={{ fontSize: '24px' }} />
    }
];
export const stepsProcurationSap: StepConfig[] = [
    {
        label: 'Procuration SAP',
        subtitle: 'Informations générales',
        icon: <AssignmentIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'Annexe 1',
        subtitle: 'Fiche de renseignement',
        icon: <AttachFileIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'Annexe 2',
        subtitle: 'Fiche d’information NOVA',
        icon: <ArticleIcon style={{ fontSize: '24px' }} />
    },
    {
        label: 'Signature',
        subtitle: 'Signer la procuration',
        icon: <EditIcon style={{ fontSize: '24px' }} />
    }
];
export const profilCompletConfig: ElementInterface[] = [
    { title: 'Statut juridique', value: 0, icons: <BusinessIcon style={{ fontSize: '24px' }} /> },
    { title: 'Procuration', value: 1, icons: <AssignmentIcon style={{ fontSize: '24px' }} /> },
    { title: 'SIRET & Adresse', value: 2, icons: <LocationOnIcon style={{ fontSize: '24px' }} /> },
    { title: 'Arrêté préfectoral', value: 3, icons: <DescriptionIcon style={{ fontSize: '24px' }} /> },
    { title: 'Signature', value: 4, icons: <EditIcon style={{ fontSize: '24px' }} /> },
    { title: 'Finalisation', value: 5, icons: <ArticleIcon style={{ fontSize: '24px' }} /> },
    { title: 'Terminé', value: 6, icons: <CheckCircleIcon style={{ fontSize: '24px' }} /> },
];

export const headerConfig = ( isValidTeachr: boolean): ElementInterface[] => ([
    { title: 'Profil', value: 1, icons: <AccountCircleRoundedIcon /> },
    { title: 'Facturation', value: 2, icons: <CreditCardRoundedIcon /> },
    { title: 'Descriptions', value: 5, icons: <DescriptionIcon /> },
    // { title: 'Adresse', value: 5, icons: <MapIcon /> },
    // { title: title ?? 'Statut juridique', value: 6, icons: <BusinessIcon />, classCustom: condition ? 'hidden' : 'flex items-center gap-x-3' },
    { title: isBrandActive(ENV_VERIFIED_TRAINER) ? 'Équipe' : 'Parrainage', value: 3, icons: <PeopleOutlineRoundedIcon />, classCustom: !isValidTeachr && !isBrandActive(ENV_VERIFIED_TRAINER) ? 'hidden' : 'flex items-center gap-x-3' },
    { title: 'Entreprise', value: 4, icons: <BusinessCenterSharpIcon />, classCustom: !isValidTeachr ? 'hidden' : 'flex items-center gap-x-3' },
])

